<template>
  <div class="multiple-image-choice">
    <el-checkbox-group v-model="issue.select">
      <ul>
        <li v-for="item in issue.items" :key="item.id" class="image-choice-box">
          <image-choice-item :item="item" :class="{ checked: issue.select.includes(item.id) }">
            <template>
              <adapter-checkbox :label="item.id" :rich-text="item.content.richText" :max="issue.max_choice">
                <div v-html="item.content.richText" class="text-theme-black-850 text-medium leading-base" ref="text"></div>
              </adapter-checkbox>
            </template>
            <template v-slot:vote>
              <vote-progress
                  v-if="showVoteProgress && issue.select.length"
                  :vote="question.vote"
                  :label="item.id"
                  :checked="issue.select.includes(item.id)"
                  :selected="!!issue.select.length"
              />
            </template>
          </image-choice-item>
        </li>
      </ul>
    </el-checkbox-group>
  </div>
</template>

<script>
import ImageChoiceItem from '@/questions/components/ImageChoiceItem'
import AdapterCheckbox from '@/questions/components/Adapter/AdapterCheckbox'
import VoteProgress from '@/questions/components/VoteProgress.vue'

export default {
  changeExpr: 'issue.select',
  name: 'MultipleImageChoice',
  components: { VoteProgress, AdapterCheckbox, ImageChoiceItem }
}
</script>
